import React from 'react'
import DemoInputsSection from '../DemoInputsSection'
import DemoInputColorSimple from './DemoInputColorSimple'

const DemoInputColor = () => {

  return (
    <DemoInputsSection name="color">
      <DemoInputColorSimple/>
    </DemoInputsSection>
  )
}

export default DemoInputColor